import { Injectable } from '@angular/core';
import {MatSnackBar} from '@angular/material';

@Injectable()
export class HelperService {
   base_url='https://s414.previewbay.com/e-learningcopy/';
   // base_url='https://app.vijayeduapp.com/backend/';
   // base_url='http://localhost/backend/';
   //base_url='http://beta.wiwlearn.com/backend/';
   add_icon="fa fa-plus my-float";
   list_icon="fa fa-list my-float";
   aws_url='https://d1zujlw06ip6yr.cloudfront.net/';
   //aws_url='https://betaanns-learning.s3.ap-south-1.amazonaws.com/';

  constructor() {

   }


}



// WEBPACK FOOTER //
// ./src/app/helper.service.ts